import BottomSheetDrag from "@components/_Revamp/BottomSheetDrag";
import Modal from "@components/_Revamp/Modal";
import { styled } from "@linaria/react";
import React from "react";
import NameSelector from "./NameSelector";

const PopUpWrapper = styled.div`
  visibility: hidden;
  @media screen and (min-width: 768px) {
    visibility: visible;
  }
`;

const ModalContainer = styled.div``;
export interface ModalNameSelectorProps {
  show?: boolean;
  onCancelClick?: () => void;
  onSaveClick?: (e: any) => void;
  headerTitle: string;
  selectorItems?: any[];
}

function ModalNameSelector({
  show = false,
  onCancelClick,
  onSaveClick,
  headerTitle,
  selectorItems = [],
}: ModalNameSelectorProps) {
  return (
    <ModalContainer>
      <PopUpWrapper>
        <Modal colseBtnColor="#883E89" show={show} onClose={onCancelClick}>
          <NameSelector
            nameSelectsFor="shieldStartter"
            visibility={show}
            onCancelClick={() => {
              if (onCancelClick) {
                onCancelClick();
              }
            }}
            onSaveClick={(value) => {
              if (onSaveClick) {
                onSaveClick(value);
              }
            }}
            headerTitle={headerTitle}
            selectorItems={selectorItems}
          />
        </Modal>
      </PopUpWrapper>
      <BottomSheetDrag
        padding={"0 24px 36px"}
        enableDrag={false}
        overlayClick={() => {
          if (onCancelClick) {
            onCancelClick();
          }
        }}
        isShow={show}
      >
        <NameSelector
          padding={"0 24px"}
          margin={"0 -24px"}
          visibility={show}
          onCancelClick={() => {
            if (onCancelClick) {
              onCancelClick();
            }
          }}
          onSaveClick={(value) => {
            if (onSaveClick) {
              onSaveClick(value);
            }
          }}
          headerTitle={headerTitle}
          selectorItems={selectorItems}
        />
      </BottomSheetDrag>
    </ModalContainer>
  );
}

export default ModalNameSelector;
